import { apiRequest } from '../client'

/**
 * API clients for machine callers — backoffice "Integrationen"
 * (CHG-2026-09-webbill-delivery-import). Always the caller's own tenant.
 *
 * No read ever carries a secret: the list shows a display prefix per token. The plaintext token is
 * returned exactly once, by `create` and `issueToken`, in an `ApiClientSecret`.
 */

export interface ApiClientToken {
  id: number
  /** First characters of the token (`pdk_…`), for telling tokens apart. Not a secret. */
  prefix: string
  active: boolean
  createdBy: string | null
  createdAt: string
  revokedBy: string | null
  revokedAt: string | null
  lastUsedAt: string | null
}

export interface ApiClient {
  id: number
  name: string
  scopes: Array<string>
  active: boolean
  createdBy: string | null
  createdAt: string
  updatedBy: string | null
  updatedAt: string
  lastUsedAt: string | null
  tokens: Array<ApiClientToken>
}

export interface ApiClientList {
  items: Array<ApiClient>
  availableScopes: Array<string>
  maxActiveTokens: number
}

/** The one response that carries a plaintext token. Never cache or persist it. */
export interface ApiClientSecret {
  client: ApiClient
  tokenId: number
  token: string
}

export interface CreateApiClientBody {
  name: string
  scopes: Array<string>
}

export interface UpdateApiClientBody {
  name?: string
  scopes?: Array<string>
  active?: boolean
}

const BASE = '/api/v0/admin/api-clients'

export const apiClientsApi = {
  list: () => apiRequest<ApiClientList>(BASE),

  create: (body: CreateApiClientBody) =>
    apiRequest<ApiClientSecret>(BASE, {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  update: (id: number, body: UpdateApiClientBody) =>
    apiRequest<ApiClient>(`${BASE}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),

  issueToken: (id: number) =>
    apiRequest<ApiClientSecret>(`${BASE}/${id}/tokens`, { method: 'POST' }),

  revokeToken: (id: number, tokenId: number) =>
    apiRequest<ApiClient>(`${BASE}/${id}/tokens/${tokenId}`, {
      method: 'DELETE',
    }),
}
